import React from 'react';

import { TextArrayProps } from '../../page-components/editorial-page-full-width/editorial-page-full-width';
import EditorialFullWidthTextAndImageBlock, {
  FullWidthTextAndImageProps,
} from '../editorial-full-width-text-and-image-block/editorial-full-width-text-and-image-block';

export interface FullWidthColumnProps {
  columnListCollection: {
    items: FullWidthTextAndImageProps[];
  };
  topBlock?: boolean;
  textItem?: TextArrayProps[];
}

const EditorialFullWidthColumnBlock = ({
  columnListCollection,
  topBlock,
  textItem,
}: FullWidthColumnProps) => {
  return (
    <div
      className={
        'grid grid-cols-1 gap-5 sm:grid-cols-2 ' +
        (topBlock &&
        !columnListCollection?.items[0]?.landscapeImageWrapper &&
        !columnListCollection?.items[0]?.portraitImageWrapper
          ? 'pt-0 '
          : ' ') +
        (topBlock ? 'sm:pt-5 lg:pt-0 ' : ' ')
      }
    >
      {columnListCollection?.items?.map((block, index) => {
        const {
          body,
          cardLink,
          externalLink,
          portraitImageWrapper,
          landscapeImageWrapper,
          imageAlignment,
          cardType,
        } = block;
        return (
          <div key={index} className="flex h-full ">
            <EditorialFullWidthTextAndImageBlock
              body={body ? body : undefined}
              cardLink={cardLink ? cardLink : undefined}
              externalLink={externalLink ? externalLink : undefined}
              portraitImageWrapper={
                portraitImageWrapper ? portraitImageWrapper : undefined
              }
              landscapeImageWrapper={
                landscapeImageWrapper ? landscapeImageWrapper : undefined
              }
              imageAlignment={imageAlignment ? imageAlignment : undefined}
              cardType={cardType ? cardType : undefined}
              textItem={textItem ? textItem[index] : undefined}
              topBlock={topBlock && index === 0 ? true : false}
            />
          </div>
        );
      })}
    </div>
  );
};

export default EditorialFullWidthColumnBlock;
